export default __webpack_public_path__ + "static/media/notification.fd21b5ef.mp3";